module.exports = __webpack_public_path__ + "img/welding3.caaadd25.png";